function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 38,
  height: 38,
  fill: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_8173_106303)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.4167 34.8333V28.2625L12.2708 33.3291L10.0542 31.1125L17.4167 23.75V20.5833H14.25L6.88749 27.9458L4.67082 25.7291L9.73749 20.5833H3.16666V17.4166H9.73749L4.67082 12.2708L6.88749 10.0541L14.25 17.4166H17.4167V14.25L10.0542 6.88746L12.2708 4.67079L17.4167 9.73746V3.16663H20.5833V9.73746L25.7292 4.67079L27.9458 6.88746L20.5833 14.25V17.4166H23.75L31.1125 10.0541L33.3292 12.2708L28.2625 17.4166H34.8333V20.5833H28.2625L33.3292 25.7291L31.1125 27.9458L23.75 20.5833H20.5833V23.75L27.9458 31.1125L25.7292 33.3291L20.5833 28.2625V34.8333H17.4167Z",
  fill: "#6086E8"
}));

function SvgSnowflake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8173_106303",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 38
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowflake);
export default __webpack_public_path__ + "static/media/snowflake.dcebf396.svg";
export { ForwardRef as ReactComponent };